export const normalizeMessage = (message) => {
  const decoded = message.replace(/\\u003c/g, "<").replace(/\\u003e/g, ">")

  const tempDiv = document.createElement("div")
  tempDiv.innerHTML = decoded

  return tempDiv.textContent || tempDiv.innerText || ""
}

export const normalizeMessages = (messages) => {
  if (!messages || !Array.isArray(messages)) return []

  return messages.map((msg) => ({
    ...msg,
    // message: normalizeMessage(msg.message),
  }))
}

export const removeFirstBr = (str) => {
  if (!str || typeof str !== "string") return str

  const parts = str.split(/<br>/i)
  if (parts.length < 2) return str

  return parts.slice(1).join("<br>").replace(/^ /, "").trim()
}
